import React, { useState, useEffect } from "react";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebase";
import moment from "moment";
import { Bell } from "./assets/svg";

const NotificationComponent = () => {
  const [notifications, setNotifications] = useState([]);
  const [fcmToken, setFcmToken] = useState(null);

  useEffect(() => {
    if (fcmToken) {
      localStorage.setItem("fcm_token", fcmToken);
    }
  }, [fcmToken]);

  useEffect(() => {
    const getFcmTokenFromFirebase = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          const token = await getToken(messaging, {
            vapidKey:
              "BNq8jr0j5O4mOD9ZRu3rr2T76IH-yN282zD7Evq7sarNuOKVeDDRapEACiM7gqBHOAogjzTZHPLtJviOGq0Pt1c",
          });
          if (token) {
            setFcmToken(token);
          }
        } else {
          console.log("Notification permission denied.");
        }
      } catch (error) {
        console.error("Error getting FCM token:", error);
      }
    };

    getFcmTokenFromFirebase();

    onMessage(messaging, (payload) => {
      const newNotification = {
        id: Date.now(),
        title: payload.notification.title,
        body: payload.notification.body,
        created_at: new Date().toISOString(),
      };

      setNotifications((prev) => [...prev, newNotification]);

      setTimeout(() => {
        setNotifications((prev) =>
          prev.filter((note) => note.id !== newNotification.id)
        );
      }, 10000);
    });
  }, []);

  return (
    notifications.length > 0 && (
      <div className="fixed top-16 right-4 z-[9999]">
        <div className="relative p-4 bg-white rounded-lg shadow-2xl mt-4 mx-8 w-[28rem]">
          <button
            onClick={() => setNotifications([])}
            className="absolute top-3 right-3 text-gray-500 hover:text-red-500 text-xl font-bold"
          >
            &times;
          </button>

          <h3 className="text-xl font-normal mb-4 flex items-center gap-2 font-Montserrat">
            <Bell className="w-5 h-5 text-themeBtn" />
            Notifications
          </h3>

          <div className="space-y-3 max-h-80 overflow-y-auto pr-2">
            {notifications.map((note) => (
              <div key={note.id} className="bg-lightTheme rounded-lg p-3">
                <div className="flex justify-between items-start mb-1">
                  <h4 className="text-base text-brown">{note.title}</h4>
                  <span className="text-xs text-primaryBlack mt-1">
                    {moment(note.created_at).format("DD/MM/YYYY | hh:mm A")}
                  </span>
                </div>
                <p className="text-xs text-primaryBlack mt-1 line-clamp-3">
                  {note.body}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  );
};

export default NotificationComponent;
